import React, { useEffect, useState } from 'react';
import StakedAntStats from './AntStatsStaked.js';
import AntStats from './AntStats.js';
import BackButton from './BackButton';
import CenterContent from './CenterContent';
import StakeDiamond from './images/Icon_Diamond.png';
import StatsInitialimg from './images/Icon_Initial.png';
import StatsTimespentimg from './images/Icon_Time.png';
import StatsEarnedimg from './images/Icon_Earned.png';
import StatsTotalimg from './images/Icon_Total.png';
import useFetchNfts from '../hooks/useFetchNfts.js';
import { useSelector } from 'react-redux';
import { selectAppBossedNft } from '../store/appSlice.js';

// Removed useWeb3 import
import Slider from 'react-slick';
import { toast } from 'react-hot-toast';
import PremiumAnt from './images/ANT.png'; // Assuming you have a default ANT image
import useSolanaWeb3 from '../hooks/useSolanaWeb3.js';
// Static data for offline demonstration
const staticBossesAssignedANTs = [
  {
    media: { mediaCollection: { high: { url: PremiumAnt } } },
    metadata: { image: PremiumAnt },
    stakedPeriod: 33, // in hours
    pendingReward: 894,
    rewardIndex: 0, // Index for the reward pool
    // Add other properties as needed
  },
  // Add more static ANTs
];

const staticBossesStakeInfo = {
  bossesPoolsInfo: [
    { poolName: 'Snail', rewardAPY: 100 },
    // Add more pool info as needed
  ],
  // Add other properties as needed
};

function BossesUnAssign({ goBack }) {
  const bossesAssignedANTs = staticBossesAssignedANTs;
  const bossesStakeInfo = staticBossesStakeInfo;

  const [antIndex, setANTIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const { handleUnBossesStake, fetchAllBalances, fetchBossedNfts } = useSolanaWeb3();
  const { fetchNfts } = useFetchNfts()
  const { nfts:bossedNft, loading:initLoading }= useSelector(selectAppBossedNft)

  const handleUnBoss = async (address) => {
    setLoading(true);
    try {
      await handleUnBossesStake(address);
      await fetchAllBalances()
      fetchNfts(10)
      await fetchBossedNfts()
      setLoading(false);
      toast.success("ANT successfully redeemed!");
    } catch (error) {
      console.error("UnBossing error:", error);
      toast.error("Failed to redeem ANT. Please try again.");
      setLoading(false);
    } finally {
      
    }
  }
 
  return (
    <section id="dashboard-unassign">
      <div className="platform-container">
        <BackButton goBack={goBack} title="Boss Fight" />
        {bossedNft.length > 0 ? <>
          <div className="center-content">
            <div className='w-[calc(32*var(--dynamic-vunit))]'>
              <Slider dots={false} infinite={true} slidesToShow={1} slidesToScroll={1} initialSlide={antIndex} afterChange={(index) => setANTIndex(index)}>
                {
                  bossedNft.map((ant, index) => {
                    return (
                      <div key={index} className='flex flex-col items-center'>
                        <img src={ant.image } alt='' className='w-[calc(32*var(--dynamic-vunit))]' />
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
          </div>
          {/* <AntStats antInfo={bossedNft[antIndex]} /> */}
          <StakedAntStats stakedNftAddress={bossedNft[antIndex]?.address} />
          <button id="select-button" onClick={() => handleUnBoss(bossedNft[antIndex]?.address)} disabled={loading}>
            <span>{loading ? "Loading..." : "REDEEM ANT"}</span>
          </button>
          <div className="rewards-main-container">
            <div className="ant-rewards-container">
              <img src={StakeDiamond} alt="Diamond" />
              <div className="rewards-text">
                <p>APY</p>
                <h1>{bossesStakeInfo.bossesPoolsInfo[bossesAssignedANTs[antIndex].rewardIndex].rewardAPY}%</h1>
              </div>
            </div>
          </div>
          <div className="container-right">
            <h2>Stats</h2>
            <div className="container-right-data-holder" id="tasks-container-right">
              <div className="rewards-text"><p>Assigned Boss</p><h1>{bossesStakeInfo.bossesPoolsInfo[bossesAssignedANTs[antIndex].rewardIndex].poolName}</h1></div></div>
            <div className="container-right-data-holder">
              <img src={StatsInitialimg} alt="Diamond" />
              <div className="rewards-text"><p>Locked</p><h1>30 Days</h1></div></div>
            <div className="container-right-data-holder">
              <img src={StatsTimespentimg} alt="Diamond" />
              <div className="rewards-text"><p>Time Left</p><h1>{Math.floor(Number(bossesAssignedANTs[antIndex].stakedPeriod) / 24)} Day {Number(bossesAssignedANTs[antIndex].stakedPeriod) % 24}H</h1></div></div>
            <div className="container-right-data-holder">
              <img src={StatsInitialimg} alt="Diamond" />
              <div className="rewards-text"><p>Initial Stake</p><h1>{10000}</h1></div></div>
            <div className="container-right-data-holder">
              <img src={StatsTotalimg} alt="Diamond" />
              <div className="rewards-text"><p>Earned Rewards</p><h1>{bossesAssignedANTs[antIndex].pendingReward}</h1></div></div>
          </div>
        </> : <><h1>You haven't assigned ANTs</h1></>}
      </div>
    </section>
  );
}

export default BossesUnAssign;